/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-11T10:54:45.434
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-RentHouseHold-'

export default 
{
path: '/rentmanage/renthousehold',
name: 'rentmanage-RentHouseHold',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}RentHouseHold-index',

meta:{
...meta,
title: '保留管理'
},

component: () => import('@/pages/rentmanage/renthousehold/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}RentHouseHold-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '保留管理编辑'
},

component: () => import('@/pages/rentmanage/renthousehold/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}RentHouseHolddetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '保留管理新增'
},

component: () => import('@/pages/rentmanage/renthousehold/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}RentHouseHoldView',
auth: [
'hidden'
],

meta:{
...meta,
title: '保留管理详情查看'
},

component: () => import('@/pages/rentmanage/renthousehold/detail-view') ,
},
]
};
